import moment from 'moment';
import { useMemo } from 'react';
var parseBooleanSetting = function (value) {
    if (!value)
        return false;
    var normalized = value.trim().toLowerCase();
    return normalized === 'true' || normalized === '1';
};
var safeDurationMinutes = function (value, fallback) {
    if (fallback === void 0) { fallback = 0; }
    if (!value)
        return fallback;
    var minutes = moment.duration(value).asMinutes();
    return Number.isFinite(minutes) ? minutes : fallback;
};
export var useCheckInStatus = function (_a) {
    var _b;
    var event = _a.event, currentUser = _a.currentUser, locationSettings = _a.locationSettings;
    return useMemo(function () {
        var _a, _b, _c, _d, _e, _f, _g;
        if (!event) {
            var now_1 = moment();
            return {
                ampEnabled: false,
                isCheckInWindowOpen: false,
                canUserConfirmCheckIn: false,
                isPastEvent: false,
                isCurrentEvent: false,
                checkInStartTime: now_1,
                checkInByTime: now_1,
            };
        }
        var now = moment();
        var confirmationWindowMinutes = safeDurationMinutes(locationSettings === null || locationSettings === void 0 ? void 0 : locationSettings['event-confirmation-window']);
        var ampEnabled = parseBooleanSetting(locationSettings === null || locationSettings === void 0 ? void 0 : locationSettings.autounbook);
        var ampThresholdMinutes = safeDurationMinutes(locationSettings === null || locationSettings === void 0 ? void 0 : locationSettings['autounbook-threshold']);
        var checkInStartTime = moment((_a = event.start) === null || _a === void 0 ? void 0 : _a.date_time).subtract(confirmationWindowMinutes, 'minutes');
        var checkInByTime = moment((_b = event.start) === null || _b === void 0 ? void 0 : _b.date_time).add(ampThresholdMinutes, 'minutes');
        var isCheckInWindowOpen = ampEnabled
            ? now.isAfter(checkInStartTime) && now.isBefore(checkInByTime)
            : now.isAfter(checkInStartTime) && now.isBefore((_c = event.end) === null || _c === void 0 ? void 0 : _c.date_time);
        var isCurrentUserAttending = Array.isArray(event.invitees) &&
            event.invitees.some(function (_a) {
                var _b;
                var user_id = _a.user_id, email = _a.email;
                return "".concat(user_id) === currentUser.id ||
                    email === ((_b = currentUser.primaryEmail) === null || _b === void 0 ? void 0 : _b.email);
            });
        var matchesUserNumericId = function (value) {
            return value != null && currentUser.id === "".concat(value);
        };
        var isCurrentUserOrganizer = matchesUserNumericId(event.organizer_id) ||
            matchesUserNumericId(event.creator_id) ||
            matchesUserNumericId(event.robin_creator_id);
        var hasManageEventPermission = ((_d = event.event_permissions) === null || _d === void 0 ? void 0 : _d.update) === true ||
            event.space_invitees.some(function (invitee) { var _a, _b; return ((_b = (_a = invitee.space) === null || _a === void 0 ? void 0 : _a.permissions) === null || _b === void 0 ? void 0 : _b['events:manage']) === true; });
        return {
            ampEnabled: ampEnabled,
            isCheckInWindowOpen: isCheckInWindowOpen,
            canUserConfirmCheckIn: isCurrentUserAttending ||
                isCurrentUserOrganizer ||
                hasManageEventPermission,
            isPastEvent: moment((_e = event.end) === null || _e === void 0 ? void 0 : _e.date_time).isBefore(now),
            isCurrentEvent: now.isBetween((_f = event.start) === null || _f === void 0 ? void 0 : _f.date_time, (_g = event.end) === null || _g === void 0 ? void 0 : _g.date_time),
            checkInStartTime: checkInStartTime,
            checkInByTime: checkInByTime,
        };
    }, [
        currentUser.id,
        (_b = currentUser.primaryEmail) === null || _b === void 0 ? void 0 : _b.email,
        event,
        locationSettings,
    ]);
};
